export class DocumentQuery {
    DocumentIds: number[];
    RefNo: string;
    Type: string;
    CifNumber: string;
    Description: string;
    MinimumDocumentDate: Date;
}